module.exports = __webpack_public_path__ + "img/mobile-close.cac3ffb7.svg";